/**
 * ログアウトコマンド
 */

import type { ArgumentsCamelCase, Argv } from 'yargs';
import { clearConfig } from '../lib/config-store.js';
import type { HelpOption } from '../lib/help-schema.js';

export function command(): string {
  return 'logout';
}

export function describe(): string {
  return 'acomo からログアウトします（ローカル設定をクリア）';
}

/** --help 用のオプション一覧（共通 help JSON 用） */
export const helpOptions: HelpOption[] = [];

export function builder(yargs: Argv): Argv {
  return yargs;
}

export async function handler(argv: ArgumentsCamelCase): Promise<void> {
  try {
    clearConfig();
    console.log('ログアウトしました。');
  } catch (error: any) {
    console.error('ログアウトに失敗しました:', error.message);
    process.exit(1);
  }
}
